import styled from 'styled-components';
import { font } from 'src/utils/variables';

export const InputLabel = styled.label`
  font-size: ${font.sizes.base};
  color: #272727;
  font-weight: ${font.weights.semibold};
  text-align: left;
  margin: 0.5rem 0;
`;